import { render, staticRenderFns } from "./PatchnoteItem.vue?vue&type=template&id=a1fd2322"
import script from "./PatchnoteItem.vue?vue&type=script&lang=js"
export * from "./PatchnoteItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports